import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { BarLoader, GridLoader } from "react-spinners";
import { MenuContext } from "../context/MenuContext";
import { TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";
import { TopBar } from "../components/topbar";
import { IoIosSearch } from "react-icons/io";
import { FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa";
import { MdAirplanemodeActive } from "react-icons/md";
import { TostMessageContext } from "../context/TostMessage";
import { FaPeopleGroup } from "react-icons/fa6";
import { Icon, SectionTitle, Pill } from "../components/icons";


export default function MakePayment() {
    const [tripType, setTripType] = useState("single");
    const [cookies] = useCookies();
    const [loading, setLoading] = useState(false);
    const progress = 0.75; // 75%
    const navigate = useNavigate();
    const {setTostMessage, userProfile} = useContext(TostMessageContext);
    const [pageData, setPageData] = useState({});
    const [airports, setAirports] = useState(cookies?.userProfile?.airports)
    const {state} = useLocation();
    const [buttonLoading, setButtonLoading] = useState(false);
    
    const PayNGN = async () => {
        const formData = new FormData();
        formData.append('flight_id', state?.flight_id);
        formData.append('flight_no', state?.flight_no);
        formData.append('passengers', JSON.stringify(state?.passengers));

        setButtonLoading(true)
        try {
            const response = await axios.post(base_url + '/make-payment/pay_ngn.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                window.open(response.data.payment_link, "_self");
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setButtonLoading(false)
        } catch (error) {
            setButtonLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }
    return(
        <div className="w-full h-full">
            <TopBar />
            <div className="w-full p-4 sm:p-6">
                <div className="mb-2">
                    <p className="max-w-xl text-sm sm:text-base text-white/40">
                        Flight {state?.flight_no} from {state?.fromAirport.city} to {state?.toAirport.city} on {state?.date}
                    </p>
                </div>
                <div className="mt-7 grid grid-cols-1 gap-6 xl:grid-cols-[2.1fr_1fr]">
                    {/* LEFT: Next Upcoming Flight */}
                    <div>
                        <div className="mx-auto w-full max-w-5xl space-y-6">
                            {/* ===== Flight Itinerary ===== */}
                            <SectionTitle icon="plane-depart" title="Flight Itinerary" />

                            <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]">

                                <div className="relative">
                                    {/* Header row */}
                                    <div className="flex flex-col gap-4 border-b border-white/10 p-5 sm:flex-row sm:items-center sm:justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-[#1a2a44]/40 text-[#d8b05a]">
                                        <Icon name="badge" />
                                        </div>

                                        <div className="min-w-0">
                                        <div className="truncate text-base font-semibold text-white/90">
                                            Roscroft Jets — {state?.flight?.flight_no}
                                        </div>
                                        <div className="mt-1 text-xs tracking-wide text-white/40">
                                            {state?.flight?.aircraft_name} • SHARED FLIGHT
                                        </div>
                                        </div>
                                    </div>

                                    <div className="sm:text-right">
                                        <div className="text-[11px] tracking-[0.28em] text-white/40">
                                        DURATION
                                        </div>
                                        <div className="mt-1 text-lg font-semibold text-white/90">
                                        {state?.flight?.duration}
                                        </div>
                                    </div>
                                    </div>

                                    {/* Timeline */}
                                    <div className="p-5 sm:p-6">
                                    <div className="relative">
                                        {/* vertical dotted line */}
                                        {/* <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-px bg-[repeating-linear-gradient(to_bottom,rgba(216,176,90,0.0)_0,rgba(216,176,90,0.0)_8px,rgba(216,176,90,0.35)_8px,rgba(216,176,90,0.35)_12px)]" /> */}

                                        {/* Stop 1 */}
                                        <div className="flex gap-x-3 w-full relative pb-10">
                                            <div className="">
                                                <div className="grid h-12 w-12 place-items-center rounded-full bg-[#d8b05a] text-black shadow-[0_20px_60px_rgba(216,176,90,0.18)]">
                                                <Icon name="plane-depart" className="h-6 w-6" />
                                                </div>
                                            </div>

                                            <div className="w-full flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                                                <div>
                                                <div className="text-3xl font-semibold text-[#d8b05a]">
                                                    {state?.flight?.departure_time}
                                                </div>
                                                <div className="mt-1 text-xl font-semibold text-white/90">
                                                    {state?.flight?.departure_airport_city} ({state?.flight?.departure_airport_iata})
                                                </div>
                                                <div className="mt-1 text-sm text-white/40">
                                                    {state?.flight?.departure_airport_name}
                                                </div>
                                                </div>
                                                <div className="text-sm text-white/40 sm:text-right">
                                                {state?.flight?.departure_date}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Stop 2 */}
                                        <div className="flex gap-x-3 w-full relative">
                                        <div className="">
                                            <div className="grid h-12 w-12 place-items-center rounded-full border border-[#d8b05a]/25 bg-[#0b0b0b] text-[#d8b05a]">
                                            <Icon name="plane-arrive" className="h-6 w-6" />
                                            </div>
                                        </div>

                                        <div className="w-full flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                                            <div>
                                            <div className="text-3xl font-semibold text-[#d8b05a]">
                                                {state?.flight?.arrival_time}
                                            </div>
                                            <div className="mt-1 text-xl font-semibold text-white/90">
                                                {state?.flight?.arrival_airport_city} ({state?.flight?.arrival_airport_iata})
                                            </div>
                                            <div className="mt-1 text-sm text-white/40">
                                                {state?.flight?.arrival_airport_name}
                                            </div>
                                            </div>
                                            <div className="text-sm text-white/40 sm:text-right">
                                            {state?.flight?.arrival_date}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mx-auto w-full max-w-5xl space-y-6 mt-6">
                            <SectionTitle icon="users" title="Primary Passenger" />
                            <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]">
                                {/* Table header */}
                                <div className="relative border-b border-white/10 px-5 py-4">
                                    <div className="grid grid-cols-12 gap-3 text-[11px] tracking-[0.28em] text-white/50">
                                    <div className="col-span-12 sm:col-span-5">NAME</div>
                                    <div className="hidden sm:block sm:col-span-3">Date of Birth.</div>
                                    <div className="hidden sm:block sm:col-span-2">Fare Type</div>
                                    </div>
                                </div>

                                {/* Rows */}
                                <div className="relative divide-y divide-white/10">
                                    {/* Row 1 */}
                                    {state?.passengers?.map((item, index) => 
                                    <div className="px-5 py-5">
                                        <div className="grid grid-cols-12 gap-3 items-center">
                                            <div className="col-span-12 sm:col-span-5 min-w-0">
                                            <div className="truncate text-base font-semibold text-white/90">
                                                {item.firstName}{" "}{item.lastName}
                                            </div>
                                            <div className="mt-1 text-sm text-white/40">
                                                {item.passport}
                                            </div>
                                            </div>
                                            <div className="col-span-6 sm:col-span-3 text-sm text-white/60 sm:text-left text-left">
                                            {item.dob}
                                            </div>
                                            <div className="col-span-12 sm:col-span-2">
                                            <Pill>{state?.flight_fares?.find(f => f.id === item.fareId)?.fare_name}</Pill>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* RIGHT: Loyalty stats */}
                    <div>
                        <div className="relative w-full max-w-md overflow-hidden rounded-3xl bg-[#2E281F] p-8 shadow-2xl">
                            {/* warm glow */}
                            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(70%_70%_at_25%_0%,rgba(216,176,90,0.22),transparent_60%)]" />
                            <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/0 via-white/0 to-black/45" />

                            <div className="relative">
                            <h2 className="text-2xl font-semibold text-white/90">
                                Payment Summary
                            </h2>

                            {/* <div className="mt-10 space-y-7">
                                <div className="flex items-center justify-between gap-4">
                                    <div className="text-lg text-white/40">{'label'}</div>
                                    <div className={`text-lg font-medium text-[#d8b05a] font-semibold`}>{value}</div>
                                </div>
                            </div> */}

                            <div className="mt-8 h-px w-full bg-[#2a3a57]/70" />

                            <div className="mt-8 flex items-end justify-between gap-6">
                                <div className="text-xl font-semibold text-white/90">
                                Total Price
                                </div>

                                <div className="text-right">
                                    <div className="text-2xl font-semibold text-[#d8b05a]">
                                        {state?.flight_fares[0]?.currency}{state?.total}
                                    </div>
                                    <div className="mt-1 text-xs tracking-[0.22em] text-white/40">
                                        ALL INCLUSIVE
                                    </div>
                                </div>
                            </div>

                            <button
                                type="button"
                                onClick={() => buttonLoading ? null : PayNGN()}
                                className={[
                                "mt-8 w-full rounded-2xl bg-[#d8b05a] px-6 h-[50px]",
                                "text-md font-extrabold tracking-wide text-[#0b0b0b]",
                                "hover:brightness-110 active:brightness-95 transition",
                                "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                                "shadow-[0_18px_60px_rgba(216,176,90,0.25)]",
                                "inline-flex items-center justify-center gap-4",
                                ].join(" ")}
                            >   
                                {buttonLoading ? <BarLoader 
                                    color={'#ffffff'}
                                    loading={true}
                                    size={7}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                /> : 
                                <>
                                    PAY in NAIRA
                                    <span className="text-[#0b0b0b]">
                                    <Icon name="lock" className="h-6 w-6" />
                                    </span>
                                </>
                                }
                            </button>

                            <div className="mt-10 flex items-center justify-center gap-3 text-xs tracking-[0.22em] text-white/40">
                                <span className="text-white/40">
                                <Icon name="checkBadge" className="h-5 w-5" />
                                </span>
                                Secure Payment
                            </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
    )
}